import get from 'lodash/get';
import { checkIsUserOptedOutAnywhere } from '../../../utils/optOut/checkUserOptOutStatus';

export default function getPpid(state) {
  const ppid = get(state, 'config.ads.targeting.ppid', '');

  return checkIsUserOptedOutAnywhere(state) ? '' : ppid;
}
